/*
  Ход обзвона для карточки «Обзвон идёт» (06.10.2026, строка 115 реестра).

  Обзвон живёт днями и идёт сам, поэтому экран спрашивает сервер каждые пять
  секунд, пока обзвон идёт, и перестаёт, как только он закончился или
  остановлен: дальше ответ не меняется. Ответ короткий намеренно - счётчики,
  кому звоним, последние и следующие, - на обзвоне в пять тысяч счетов полный
  список каждые пять секунд был бы лишним грузом.
*/

import { useCallback, useEffect, useState } from 'react'

import { api } from '../api/client.js'

export const POLL_MS = 5000

export default function useCallWave() {
  const [wave, setWave] = useState(null)
  const [loaded, setLoaded] = useState(false)
  const [error, setError] = useState(null)
  // Отказ остановки хранится отдельно от ошибки чтения (аудит 26.10.2026, причина 7): опрос
  // каждые пять секунд снимал общую ошибку при первом удачном ответе, и отказ «остановить
  // не вышло» исчезал, пока человек его читал - обзвон при этом продолжал идти.
  const [stopError, setStopError] = useState(null)
  const [stopping, setStopping] = useState(false)

  const refresh = useCallback(
    () =>
      api
        .currentCallWave()
        .then((answer) => {
          setWave(answer.wave)
          setError(null)
        })
        .catch(setError)
        .finally(() => setLoaded(true)),
    [],
  )

  useEffect(() => {
    refresh()
  }, [refresh])

  const running = wave?.state === 'running'
  useEffect(() => {
    if (!running) return undefined
    const timer = setInterval(refresh, POLL_MS)
    return () => clearInterval(timer)
  }, [running, refresh])

  const stop = useCallback(async () => {
    if (!wave) return
    setStopping(true)
    setStopError(null)
    try {
      setWave(await api.stopCallWave(wave.id))
    } catch (failure) {
      setStopError(failure)
    } finally {
      setStopping(false)
    }
  }, [wave])

  return { wave, loaded, error, stopError, stopping, stop, refresh }
}
